import { useEffect } from 'react';
import { Col, DatePicker, Form, Modal, Row } from 'antd';
import { useGetChildTaskStatusQuery, useGetChildTaskTypesQuery } from '@/services/general-api';
import { useAddChildTaskReferralMutation } from '@/services/child-api';
import Select from '@/components/select';
import moment from 'moment';

const AddModal = ({ childId, open, refetch, onClose }) => {
  const { data: taskTypeData, isLoading: loadingTaskTypeData } = useGetChildTaskTypesQuery();
  const { data: statusData, isLoading: loadingStatusData } = useGetChildTaskStatusQuery();
  const [addReferral, { isLoading: adding }] = useAddChildTaskReferralMutation();
  const [form] = Form.useForm();

  useEffect(() => {
    if (open) {
      setTimeout(() => {
        form.resetFields();
      });
    }
  }, [open, form]);

  const onFinish = async (values) => {
    try {
      await addReferral({
        childId,
        body: {
          referral: values.referral.toISOString(),
          taskItems: [
            {
              type: { id: values.taskId },
              status: { id: values.statusId },
            },
          ],
        },
      }).unwrap();

      refetch();
      onClose();
    } catch (err) {}
  };

  return (
    <Modal
      title="Add Referral"
      open={open}
      okText="Add"
      confirmLoading={adding}
      onOk={() => form.submit()}
      onCancel={onClose}
    >
      <Form layout="vertical" form={form} onFinish={onFinish}>
        <Form.Item name="referral" label="Referral Date" rules={[{ required: true }]}>
          <DatePicker
            format="MM/DD/YYYY"
            onBlur={(e) => {
              const inputVal = e.target.value;
              const validDate = moment(inputVal, ['M/D/YYYY', 'MM/DD/YYYY'], true);
              if (validDate.isValid()) {
                form.setFieldsValue({
                  referral: validDate,
                });
              } else {
                form.setFieldsValue({
                  referral: null,
                });
              }
            }}
          />
        </Form.Item>
        <Row gutter={24}>
          <Col span={12}>
            <Form.Item name="taskId" label="Task" rules={[{ required: true }]}>
              <Select options={taskTypeData} loading={loadingTaskTypeData} />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item name="statusId" label="Status" rules={[{ required: true }]}>
              <Select options={statusData} loading={loadingStatusData} />
            </Form.Item>
          </Col>
        </Row>
      </Form>
    </Modal>
  );
};

export default AddModal;
